var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('img',{attrs:{"src":require("../../../assets/img/order_not.png"),"alt":""}}),_c('p',[_vm._v("亲，暂无相关订单哦")])])}]

export { render, staticRenderFns }